import {Col, Form, Input, Row} from "antd";
import React from "react";

const {TextArea} = Input;
// Компонент полей ввода основной информации

export const BasicInfoFields = () => (
    <Row gutter={16}>
        <Col span={12}>
            <Form.Item
                name="name"
                label="Название ведомости"
                rules={[
                    {required: true, message: 'Введите название'},
                    {max: 100, message: 'Максимум 100 символов'}
                ]}
            >
                <Input placeholder="Например: Зарплата за январь"/>
            </Form.Item>
        </Col>
        <Col span={12}>
            <Form.Item
                name="description"
                label="Описание"
                rules={[
                    {max: 500, message: 'Максимум 500 символов'}
                ]}
            >
                <TextArea
                    placeholder="Описание ведомости..."
                    rows={3}
                    maxLength={500}
                    showCount
                />
            </Form.Item>
        </Col>
    </Row>
);